import React,{useState,useEffect,useRef} from 'react';
import { Accordion,Col } from 'react-bootstrap';
import CheckboxField from '../CheckboxField/CheckboxField';
import { Link } from "react-router-dom";
import Axios from '../../lib/axios/axiosInstance';
import {BASE_URL} from '../../lib/constant';
import Modal from 'react-bootstrap/Modal';
import ProductComparison from '../ProductComparison';
import * as AuthVerify from '../../lib/common';
import './ProductListSidebar.styles.css';

const ProductListSidebar = ({ leftSideData ,compareProductListUpdated,dispatch,colorFilterHandler, showShopBy=true, isMobile=false}) => {
  
  const [comapreProducts, setComapreProducts] = useState(false); 
  const [recentProducts, setRecentProducts] = useState(false); 
  const [mShow, setMShow] = useState(false);
  const [mobileViewAction, setMobileViewAction] = useState(false);
  const [colors, setColors] = useState([]);
  const [selectedlabels, setSelectedLabels] = useState([])

  const loadProducts = async (data,compare=false,recent=false) =>{
    // RECENTLY VIEWED
    // api/product/viewed
    await Axios.post(`/product/viewed`,{
      "items":data
    })
    .then(function (response) {
        if (response && response.data?.data?.items) {
          if(compare)setComapreProducts(response.data?.data?.items);
          if(recent)setRecentProducts(response.data?.data?.items);
        }
        else {
          if(compare)setComapreProducts([]);
          if(recent)setRecentProducts([]);
          return false;
        }
    })
    .catch(function (error) {
      setComapreProducts([]);
      setRecentProducts([]);
      return false;
    }); 
  }

  useEffect(async () => {
    setMobileViewAction(isMobile);
    if(showShopBy){
      leftSideData?.data?.colourList.map((data)=>{
        colors.push({color:data.grp.varid,value:false})
      })
      setColors(colors);
    }
    await AuthVerify.removeColours();
  }, [leftSideData?.data?.colourList]);

  useEffect(async () => {
    setMobileViewAction(isMobile);
    await AuthVerify.removeLabels();
  }, [leftSideData?.data?.labelList]);

  useEffect(() => {
      AuthVerify.compareProducts().then((data) => {
        if(data){
          loadProducts(data,true);
        }
      })
      AuthVerify.recentsProducts().then((data) => {
        if(data){
          loadProducts(data,false,true);
        }
      })
  }, [compareProductListUpdated])

  const removeFromCompareProducts =(matnum) => {
    AuthVerify.removeFromCompares(matnum).then((data) => {
      if(data){
        loadProducts(data,true);
      }
    })
  }

  
  const CompareProductListView = () => {
    return (
    <Accordion defaultActiveKey="" flush>
      {comapreProducts && comapreProducts.map((item,i)=>{
        return(<li className="item" key={i}>
        <button className="jtv-btn-remove" title="Remove This Item" onClick={()=>removeFromCompareProducts(item.matnum)}></button> 
        <Accordion.Item eventKey={i}>
            <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>{item.matname}</Accordion.Header>
            <Accordion.Body style={{textAlign:"center"}}>
              <Link to={"/product-detail?matnum="+item.matnum}>
                <img
                    alt={item?.matname}
                    // src={img03}
                    // src={BASE_URL+item?.imageurl}
                    src={AuthVerify.getImageLink(item?.imageurl)}
                    style={{maxWidth:"100px"}}
                />
              </Link>
            </Accordion.Body>
          </Accordion.Item> </li>)
      })}
    </Accordion>
    )
  }

  const RecentProductListView = () => {
    return (
    <Accordion defaultActiveKey="" flush>
      {recentProducts && recentProducts.map((item,i)=>{
        return(<li className="item" key={i}>
        <Accordion.Item eventKey={i}>
            <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>{item.matname}</Accordion.Header>
            <Accordion.Body style={{textAlign:"center"}}>
              <Link to={"/product-detail?matnum="+item.matnum}>
                <img
                    alt={item?.matname}
                    // src={img03}
                    // src={BASE_URL+item?.imageurl}
                    src={AuthVerify.getImageLink(item?.imageurl)}
                    style={{maxWidth:"100px"}}
                />
              </Link>
            </Accordion.Body>
          </Accordion.Item> </li>)
      })}
    </Accordion>
    )
  }

  const updateColorCheckList=async (data) => {

      let totalSelecteion = data.filter(x=>x.value==true);
      let colorFilter='';
      totalSelecteion.map((item) => {
        colorFilter+=`&colour=${item.color}`
      })
      await AuthVerify.addToColours(colorFilter).then(async (colours) => {
        await AuthVerify.sortByProducts().then((sortBy) => {
          var sortByData = sortBy.split('|');
          let url=`${colorFilter}&sortby=${sortByData[0]}&orderby=${sortByData[1]}`;
          colorFilterHandler(url);
        })
      })
  }

  const colorSelectEventHandle = (data,e) => {
    colors.map((color) => {
      if( color.color==data.grp.varid){
        color.value=e.target.checked;
      }
    })
    setColors(colors)
    updateColorCheckList(colors)
  }

  const labelSelectEventHandle = async (data, e) => {
    let selected = [...selectedlabels];
    if (e.target.checked)
      selected.push(data.labels.labelnum);
    else
      selected = [...selectedlabels].filter((item) => { return item != data.labels.labelnum })
    setSelectedLabels(selected);

    let labelFilter = '';
    selected.map((item) => {
      labelFilter += `&label=${item}`
    })
    console.log(labelFilter);

    await AuthVerify.addToLabels(labelFilter).then(async () => {
      await AuthVerify.sortByProducts().then((sortBy) => {
        var sortByData = sortBy.split('|');
        let url=`${labelFilter}&sortby=${sortByData[0]}&orderby=${sortByData[1]}`;
        colorFilterHandler(url);
      })
    })
  }

  return (
    <aside className="sidebar">

      {showShopBy && 
      <div className="block block-layered-nav">
        <div className="block-title">Shop By 
        {isMobile && <button style={{float: 'right'}} onClick={()=>setMobileViewAction(!mobileViewAction)}>{mobileViewAction ? "Show Details": "Hide Details"}</button>}
        </div>
        {!mobileViewAction && 
          <div className="block-content">
            <p className="block-subtitle">Shopping Options</p>
            <dl id="narrow-by-list">
              {
                leftSideData?.data?.ProductList && 
                <> 
                  <dt className="odd">Categories</dt>
                  <Accordion defaultActiveKey="" flush style={{ overflowY: "auto" }}>
                      {
                        leftSideData?.data?.ProductList.map((data, i) => {
                          return (
                            <Accordion.Item eventKey={i}>
                              <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span><Link to={"/category?name=" + data.grp.url?.split("/")[1]}>{data.grp.varname} {data.subgrp && `(${data.subgrp.length})`}</Link></Accordion.Header>
                              {data.subgrp?.map((item, j) => {
                                return (
                                  <Accordion.Body>
                                    <Accordion defaultActiveKey="" flush style={{ overflowY: "auto" }}>
                                      <Accordion.Item eventKey={j}>
                                        <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span><Link to={"/category?name=" + item.grp.url?.split("/")[1]}>{item.grp.varname} {item.subgrp && `(${item.subgrp.length})`}</Link></Accordion.Header>
                                        {item.subgrp?.map((item2, k) => {
                                          return (
                                            <Accordion.Body>
                                              <Link to={"/category?name=" + item2.grp.url?.split("/")[1]}>{item2.grp.varname}</Link>
                                            </Accordion.Body>)
                                        })}
                                      </Accordion.Item>
                                    </Accordion>
                                  </Accordion.Body>
                                )
                              })}

                            </Accordion.Item>
                          )
                        })
                      }
                    </Accordion>
                </>
              }
              <br/>
              {
                leftSideData?.data?.brandList && 
                <>
                  <dt className="even">Brands</dt>
                  <Accordion defaultActiveKey="" flush style={{maxHeight:"280px", overflowY:"auto"}}>
                    {
                      leftSideData?.data?.brandList.map((data,i) => {
                        return (
                          <Accordion.Item eventKey={`${i}`} key={i}>
                            <Accordion.Header>
                              <Link to={"/brand?name="+data.grp.url?.split("/")[1]}>{data.grp.varname}</Link>
                            </Accordion.Header>
                          </Accordion.Item>
                        )
                      })
                    }
                  </Accordion>
                </>
              }
              <br/>
              {
                leftSideData?.data?.colourList && 
                <>
                  <dt className="odd">Color</dt>
                  <dd className="odd" style={{maxHeight:"280px", overflowY:"auto"}}>
                  <ol className="bag-material">
                    {
                      leftSideData?.data?.colourList.map((data,i) => {
                        return (
                          <li key={i}> <CheckboxField Type="checkbox" 
                          onChange={e=>{colorSelectEventHandle(data,e)}} 
                          Labels={data.grp.varname} Value={data.grp.varid} Name={data.grp.varname}/> </li>
                        )
                      })
                    }
                    </ol>
                  </dd>
                </>
              }
              <br/>
              {
                leftSideData?.data?.labelList && 
                <>
                  <dt className="odd">Label</dt>
                  <dd className="odd" style={{maxHeight:"280px", overflowY:"auto"}}>
                  <ol className="bag-material">
                    {
                      leftSideData?.data?.labelList.map((data,i) => {
                        return (
                          <li key={i}> <CheckboxField Type="checkbox" 
                          onChange={e=>{labelSelectEventHandle(data,e)}} 
                          Labels={data.labels.labelname} Value={data.labels.labelnum} Name={data.labels.labelname}/> </li>
                        )
                      })
                    }
                    </ol>
                  </dd>
                </>
              }

              {/* <dt className="odd">Listing</dt>
                <Accordion defaultActiveKey="" flush>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>Best Selling</Accordion.Header>
                    <Accordion.Body>
                        Test
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>Featured Product</Accordion.Header>
                    <Accordion.Body>
                      Test
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>New Arrival</Accordion.Header>
                    <Accordion.Body>
                      Test
                    </Accordion.Body>
                  </Accordion.Item>
                  </Accordion> */}
            </dl>
          </div>
        }
      </div>
      }

      {!mobileViewAction && 
      <>

      {/* <div className="block product-price-range ">
        <div className="block-title">Price</div>
        <div className="block-content">
          <div className="slider-range">
            <div data-label-reasult="Range:" data-min="0" data-max="500" data-unit="$" className="slider-range-price ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all" data-value-min="50" data-value-max="350">
              <div className="ui-slider-range ui-widget-header ui-corner-all" style={{ left: '10%', width: '60%' }}></div>
              <span className="ui-slider-handle ui-state-default ui-corner-all" tabIndex="0" style={{ left: '10%' }}></span><span className="ui-slider-handle ui-state-default ui-corner-all" tabIndex="0" style={{ left: '70%' }} ></span></div>
            <div className="amount-range-price">Range: $10 - $550</div>
            <ul className="check-box-list">
              <li>
                <input type="checkbox" id="p1" name="cc" />
                <label htmlFor="p1"> <span className="button"></span> $20 - $50<span className="count">(5)</span> </label>
              </li>
              <li>
                <input type="checkbox" id="p2" name="cc" />
                <label htmlFor="p2"> <span className="button"></span> $50 - $100<span className="count">(10)</span> </label>
              </li>
              <li>
                <input type="checkbox" id="p3" name="cc" />
                <label htmlFor="p3"> <span className="button"></span> $100 - $250<span className="count">(12)</span> </label>
              </li>
            </ul>
          </div>
        </div>
      </div> */}

      <div className="block block-compare">
        <div className="block-title ">Compare Products ({comapreProducts?comapreProducts?.length:0})</div>
        <div className="block-content">
          <ol id="compare-items">
            <CompareProductListView/>
          </ol>
          <div className="ajax-checkout">
            <button type="submit" title="Submit" className="button button-compare" onClick={()=>setMShow(true)}><span>Compare</span></button>
            <button type="submit" title="Submit" className="button button-clear" onClick={()=>removeFromCompareProducts()}><span>Clear</span></button>
          </div>
        </div>
      </div>

      {/* <div className="custom-slider">
        <div>
          <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
            <ol className="carousel-indicators">
              <li className="active" data-target="#carousel-example-generic" data-slide-to="0"></li>
              <li data-target="#carousel-example-generic" data-slide-to="1" className=""></li>
              <li data-target="#carousel-example-generic" data-slide-to="2" className=""></li>
            </ol>
            <div className="carousel-inner">
              <div className="item active"><img src="images/slide3.jpg" alt="slide3" />
                <div className="carousel-caption">
                  <h3><Link title=" Sample Product" to="/product-list">Big Sale</Link></h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  <Link className="link" to="/product-list">Shop Now</Link></div>
              </div>
              <div className="item"><img src="images/slide1.jpg" alt="slide1" />
                <div className="carousel-caption">
                  <h3><Link title=" Sample Product" to="/product-list">New Collection</Link></h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </div>
              <div className="item"><img src="images/slide2.jpg" alt="slide2" />
                <div className="carousel-caption">
                  <h3><Link title=" Sample Product" to="/product-list">New Special</Link></h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </div>
            </div>
            <Link className="left carousel-control" to="/product-list" data-slide="prev"> <span className="sr-only">Previous</span> </Link> <Link className="right carousel-control" to="/product-list" data-slide="next"> <span className="sr-only">Next</span> </Link></div>
        </div>
      </div> */}

      <div className="block block-list block-viewed">
        <div className="block-title"> Recently Viewed </div>
        <div className="block-content">
          <ol id="recently-viewed-items">
            {/* <Accordion defaultActiveKey="" flush>
            <li className="item odd">
              <Accordion.Item eventKey="0">
                <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>Product Title Here</Accordion.Header>
                <Accordion.Body>
                    Test
                </Accordion.Body>
              </Accordion.Item> 
            </li>
            <li className="item even">
              <Accordion.Item eventKey="1">
                <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>Product Title Here</Accordion.Header>
                <Accordion.Body>
                    Test
                </Accordion.Body>
              </Accordion.Item>
            </li>
            <li className="item last odd">
              <Accordion.Item eventKey="2">
                <Accordion.Header><span><i className="fa fa-angle-right" aria-hidden="true"></i></span>Product Title Here</Accordion.Header>
                <Accordion.Body>
                    Test
                </Accordion.Body>
              </Accordion.Item>
            </li>
            </Accordion> */}
            <RecentProductListView/>
          </ol>
        </div>
      </div>

      {/* <div className="block block-poll">
        <div className="block-title">Community Poll </div>
        <form id="pollForm" >
          <div className="block-content">
            <p className="block-subtitle">What is your favorite color</p>
            <ul id="poll-answers">
              <li className="odd">
                <CheckboxField Type="radio" Labels="Green" Value="1" Name="vote" className="radio poll_vote"/>
                </li>
              <li className="even">
                <CheckboxField Type="radio" Labels="Brown" Value="2" Name="vote" className="radio poll_vote"/>
                </li>
              <li className="odd">
                <CheckboxField Type="radio" Labels="Orange" Value="3" Name="vote" className="radio poll_vote"/>
                </li>
              <li className="last even">
                <CheckboxField Type="radio" Labels="Pink" Value="4" Name="vote" className="radio poll_vote"/>
                </li>
            </ul>
            <div className="actions">
              <button type="submit" title="Vote" className="button button-vote"><span>Vote</span></button>
            </div>
          </div>
        </form>
      </div>

      <div className="block block-tags">
        <div className="block-title"> Popular Tags</div>
        <div className="block-content">
          <div className="tags-list"> <Link to="/product-list">Clutches</Link> <Link to="/product-list">Bag</Link> <Link to="/product-list">Laptop bags</Link> <Link to="/product-list">Luggage</Link> <Link to="/product-list">Backpacks</Link> <Link to="/product-list">Piper Bag</Link> </div>
          <div className="actions"> <Link to="/product-list" className="view-all">View All Tags</Link> </div>
        </div>
      </div> */}

      {isMobile && <Col md={12} style={{textAlign: 'center'}}><button className={"btn btn-primary"} onClick={()=>setMobileViewAction(!mobileViewAction)}>{mobileViewAction ? "Show Details": "Hide Details"}</button><hr/></Col>}
      </>}

      <Modal show={mShow} dialogClassName="modal-90w" size="lg" animation={false} fade={false} style={{opacity:1}} onHide={()=>setMShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Product Comparison</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProductComparison/>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={()=>setMShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>
    </aside>
  );
};

export default ProductListSidebar;
